export function scrollToPosition(x: number, y: number): void {
  if (typeof window !== 'undefined') {
    window.scrollTo(x, y);
  }
}

export function getCurrentScrollY(): number {
  if (typeof window === 'undefined') return 0;
  return window.scrollY;
}

export function addScrollListener(
  handler: () => void,
  options?: AddEventListenerOptions,
): () => void {
  if (typeof window === 'undefined') return () => {};

  window.addEventListener('scroll', handler, options);
  return () => window.removeEventListener('scroll', handler);
}

export function getHostname(): string {
  return window.location.hostname;
}

export function getPathname(): string {
  if (typeof window === 'undefined') return '';
  return window.location.pathname;
}
